import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { DELETE_QUESTION } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { DeleteQuestionDataActionTypes } from './types';
import api from 'src/utils/api';
import { loadAllListQuestions } from '../allListQuestions/actions';

export const loadDeleteQuestion =
  (
    idSurvey: number,
    idQuestion: number,
  ): ThunkAction<Promise<void>, State, null, DeleteQuestionDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: DELETE_QUESTION + REQUEST });
    try {
      const payload = await api.loadDeleteQuestion(idSurvey, idQuestion);
      dispatch({ type: DELETE_QUESTION + SUCCESS, payload });
      dispatch(loadAllListQuestions(idSurvey));
    } catch (error) {
      dispatch({ type: DELETE_QUESTION + FAILURE, error });
    }
  };

export const deleteQuestionIdle = () => ({ type: DELETE_QUESTION + IDLE });
